/**
 * Remove a CSS class from an element if present
 * @param element HTML Element
 * @param className Name of CSS class
 */
export function removeClass(element: HTMLElement, className: string): void {
    if (element.classList.contains(className)) {
        element.classList.remove(className);
    }
}